import React, { useEffect, useState } from 'react';
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton, { SaveButtonProps } from '../../../components/Buttons/SaveButton';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import ButtonBar from '../../../components/Fields/ButtonBar';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import PriceModel from '../../../models/PriceModel';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import { Result } from '../../../types/Result';
import AddPricePopup from '../Popups/ItemRevision_popup_AddPrice';

const ItemRevision_tab_Prices: React.FC<ItemRevisionProps> = ({ itemId, itemRevisionId, itemTypeId }) => {
    const [tableData, setData] = useState<PriceModel[]>();
    const [serverErrors, setServerErrors] = useState<Result[]>();
    const { handleResult, handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const businessPartners = useSelectListOptions('api/v1/selectlist/BusinessPartners?activeOnly=true', '-- Select business-partner');
    const currencies = useSelectListOptions('api/v1/selectlist/CurrencySymbols', '-- Select currency');
    const incoTerms = useSelectListOptions('api/v1/selectlist/IncoTerms', '-- Select incoterms');
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemId]);

    function getTableData() {
        DataService.get<PriceModel[]>('api/v1/Prices/ByItem/' + itemId)
            .then(response => {
                setData(response);
                console.log('Data from server:', response)
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/Prices/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    console.log('data', tableData)

    function onCellChange(value: any, rowIndex: number, dataProp?: string)
    {
        console.log('cell change', value, rowIndex, dataProp)
        console.log('tableData', tableData)
        if (tableData && dataProp) {
            dataProp.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setData(tableData.slice());
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, tableData[rowIndex]);
        }
    }

    function SaveChanges() {
        console.log('tableData', tableData)

        if (tableData) {
            DataService
                .updateTableData<PriceModel>(`api/v1/Prices/UpdatePrices`, tableData)
                .then(response => {
                    let succesful = true
                    response.forEach((result) => {
                        handleResult(result);
                        if (result.isSuccesful == false)
                            succesful = false;
                    });

                    setServerErrors(response);

                    if (succesful === true)
                        getTableData();
                        //setFormData(response.data);
                })
                .catch(e => handleException(e));
        }    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Type', dataProp: 'priceType.name', sort: 'asc', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Volume', dataProp: 'priceTranche' },
        { title: 'Currency', dataProp: 'currencyId', editable: true, options: currencies, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Price', dataProp: 'amount', align: 'right', dataType: 'decimal', editable: true },
        { title: 'Incoterms', dataProp: 'incoTermId', editable: true, width: 200, options: incoTerms, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Business partner', dataProp: 'businessPartnerId', editable: true, width: 300, options: businessPartners, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date', editable: true },
        { title: 'End date', dataProp: 'endDate', dataType: 'date', editable: true },
        { title: 'Remarks', dataProp: 'remarks', editable: true, filterInfo: { filterType: 'Textbox' } },
    ];

    if (isAuthorizedForItemType(ApplicationFunctions.EditItemPrice, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    const saveButtonProps: SaveButtonProps = {
        onClick: SaveChanges
    }

    if (businessPartners && incoTerms && currencies) {
        return (
            <>
                <DataTable key='dtItemPrices'
                    name='dtItemPrices'
                    colInfos={colInfos}
                    tableData={tableData}
                    serverErrors={serverErrors}
                    onCellChange={onCellChange}
                    navigateTitle='Price'
                    navigateUrl='/plm/Items/Price/'
                />
                <ButtonBar offset={2}>
                    <Authorize applicationFunction={ApplicationFunctions.EditItemPrice}>
                        <SaveButton  {...saveButtonProps} />
                    </Authorize>
                </ButtonBar>
                {showPopup && <AddPricePopup itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={itemTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
            </>
        );
    }

    return null;
}
export default ItemRevision_tab_Prices;